module.exports = __webpack_public_path__ + "static/media/Location-Guide.f15d3f3e.png";